import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton, DashboardAnalyticsSkeleton } from '@/components/molecules/skeletons';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const DashboardPageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <DashboardAnalyticsSkeleton />
      </div>
    </PageContainer>
  );
});

DashboardPageSkeleton.displayName = 'DashboardPageSkeleton';
